import { useCallback, useState } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { Crisp } from "crisp-sdk-web";
import { AuthContext } from "./auth-context.js";

export default function AuthProvider({ children }) {
  const [auth, setAuth] = useState({});

  const buildAndSetAuth = useCallback((data) => {
    const auth = {
      accessToken: data.access_token,
      userId: data.id_compte,
      mail: data.mail,
      home: data.home,
      role: data.role,
    };
    if (data.impersonator) {
      auth.impersonator = {
        userId: data.impersonator.id_compte,
        mail: data.impersonator.mail,
      };
    }
    setAuth(auth);
    datadogRum.setUser({
      id: data.id_compte,
      email: data.mail,
    });

    Crisp.user.setEmail(data.mail, data.crisp_signature);
    Crisp.user.setNickname(data.mail);
    Crisp.session.setData({
      user_id: data.id_compte,
      home: data.home,
    });
  }, []);

  const resetAuth = useCallback(() => {
    setAuth({});
    datadogRum.clearUser();
    Crisp.session.reset();
  }, []);

  const contextValue = {
    auth,
    isImpersonated: !!auth.impersonator,
    isPro: auth.home === "/pro",
    buildAndSetAuth,
    resetAuth,
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
}
